export interface Figure {
  id: string;
  type: string;
  color: string;
  size: 'small' | 'medium' | 'large';
  name: string;
}

export interface PlacedFigure extends Figure {
  x: number;
  y: number;
  rotation: number;
  scale: number;
}

export const availableFigures: Omit<Figure, 'id'>[] = [
  { type: 'family-elder', color: '#8B4513', size: 'large', name: 'Дедушка/Бабушка' },
  { type: 'family-elder', color: '#D2691E', size: 'large', name: 'Пожилой человек' },
  { type: 'family-adult', color: '#F4A460', size: 'medium', name: 'Взрослая женщина' },
  { type: 'family-adult', color: '#CD853F', size: 'medium', name: 'Взрослый мужчина' },
  { type: 'family-adult', color: '#DEB887', size: 'medium', name: 'Родитель' },
  { type: 'family-teen', color: '#FFB6C1', size: 'medium', name: 'Подросток' },
  { type: 'family-teen', color: '#87CEEB', size: 'medium', name: 'Тинейджер' },
  { type: 'family-child', color: '#FF6B6B', size: 'small', name: 'Ребенок' },
  { type: 'family-child', color: '#4ECDC4', size: 'small', name: 'Малыш' },
  { type: 'family-child', color: '#95E1D3', size: 'small', name: 'Дошкольник' },
  { type: 'family-baby', color: '#FFE5E5', size: 'small', name: 'Младенец' },
  { type: 'family-baby', color: '#FFD6D6', size: 'small', name: 'Новорожденный' },
  { type: 'emotional-calm', color: '#E8D5B7', size: 'medium', name: 'Спокойный/ая' },
  { type: 'emotional-calm', color: '#C0A080', size: 'medium', name: 'Умиротворенный/ая' },
  { type: 'emotional-upset', color: '#2C3E50', size: 'medium', name: 'Расстроенный/ая' },
  { type: 'emotional-upset', color: '#34495E', size: 'medium', name: 'Кричащий/ая' },
  { type: 'emotional-upset', color: '#000000', size: 'medium', name: 'Злой/ая' },
  { type: 'emotional-happy', color: '#FFA07A', size: 'medium', name: 'Радостный/ая' },
  { type: 'emotional-happy', color: '#FFD700', size: 'medium', name: 'Веселый/ая' },
  { type: 'house', color: '#F5DEB3', size: 'large', name: 'Дом' },
  { type: 'house', color: '#D2B48C', size: 'medium', name: 'Маленький дом' },
  { type: 'tree', color: '#8FBC8F', size: 'medium', name: 'Дерево' },
  { type: 'tree', color: '#6B8E23', size: 'medium', name: 'Большое дерево' },
  { type: 'tree', color: '#9ACD32', size: 'small', name: 'Кустик' },
  { type: 'animal-dog', color: '#D2691E', size: 'small', name: 'Собака' },
  { type: 'animal-dog', color: '#F4A460', size: 'small', name: 'Щенок' },
  { type: 'animal-cat', color: '#C0C0C0', size: 'small', name: 'Кошка' },
  { type: 'animal-cat', color: '#FFE4B5', size: 'small', name: 'Котенок' },
  { type: 'animal-bird', color: '#87CEEB', size: 'small', name: 'Птица' },
  { type: 'cocoon', color: '#FFE4C4', size: 'small', name: 'Кокон' },
  { type: 'cocoon', color: '#F5DEB3', size: 'small', name: 'Пеленки' },
  { type: 'striped', color: '#000000', size: 'medium', name: 'Полосатая фигура' },
  { type: 'striped', color: '#4169E1', size: 'medium', name: 'Узорная фигура' },
  { type: 'person', color: '#8B4513', size: 'small', name: 'Человек (коричневый)' },
  { type: 'person', color: '#2C3E50', size: 'small', name: 'Человек (черный)' },
  { type: 'person', color: '#3498DB', size: 'small', name: 'Человек (синий)' },
  { type: 'person', color: '#95A5A6', size: 'small', name: 'Человек (серый)' },
  { type: 'person', color: '#16A085', size: 'small', name: 'Человек (зеленый)' },
  { type: 'person', color: '#E74C3C', size: 'small', name: 'Человек (красный)' },
  { type: 'person', color: '#F39C12', size: 'small', name: 'Человек (оранжевый)' },
  { type: 'person', color: '#C0A080', size: 'medium', name: 'Человек средний (бежевый)' },
  { type: 'person', color: '#E8D5B7', size: 'medium', name: 'Человек средний (светлый)' },
  { type: 'person', color: '#8B6F47', size: 'medium', name: 'Человек средний (темный)' },
  { type: 'tall', color: '#A89968', size: 'large', name: 'Высокая фигура (золотая)' },
  { type: 'tall', color: '#5F7A7A', size: 'large', name: 'Высокая фигура (бирюзовая)' },
  { type: 'tall', color: '#8E7CC3', size: 'large', name: 'Высокая фигура (фиолетовая)' },
  { type: 'tall', color: '#D5D5D5', size: 'large', name: 'Высокая фигура (белая)' },
  { type: 'ball', color: '#1ABC9C', size: 'medium', name: 'Шар (бирюзовый)' },
  { type: 'ball', color: '#E74C3C', size: 'medium', name: 'Шар (красный)' },
  { type: 'ball', color: '#ECF0B1', size: 'medium', name: 'Шар (желтый)' },
  { type: 'ball', color: '#9B59B6', size: 'medium', name: 'Шар (фиолетовый)' },
  { type: 'ball', color: '#FF69B4', size: 'small', name: 'Шарик (розовый)' },
];

export function getFigureSize(size: Figure['size']): number {
  switch (size) {
    case 'small': return 48;
    case 'medium': return 64;
    case 'large': return 80;
  }
}
